export const CORE_WINDOW_IDS = {
    PROPERTIES: "properties",
    SETTINGS: "settings",
    OBJECT_TREE: "objectTree",
    DIMENSION: "dimension",
    RENDER_POINT_CLOUD: "renderPointCloud",
} as const;

/** Kept out of {@link CORE_WINDOW_IDS}, which is public API. */
export const DEBUG_UTILS_WINDOW_ID = "debugUtils";

export type CoreWindowId = (typeof CORE_WINDOW_IDS)[keyof typeof CORE_WINDOW_IDS];
